import { render, staticRenderFns } from "./all-overview.vue?vue&type=template&id=f484c4cc&scoped=true"
import script from "./all-overview.vue?vue&type=script&lang=ts"
export * from "./all-overview.vue?vue&type=script&lang=ts"
import style0 from "./all-overview.vue?vue&type=style&index=0&id=f484c4cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f484c4cc",
  null
  
)

export default component.exports